import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Rewind = createReactComponent("Rewind", ["svg", defaultAttributes, [["polygon", {
  points: "11 19 2 12 11 5 11 19",
  key: "231j3z"
}], ["polygon", {
  points: "22 19 13 12 22 5 22 19",
  key: "1r8x43"
}]]]);
export default Rewind;